import { z } from 'zod';

/**
 * Transit to fulfillment center details validation schema
 * Used when marking an order as in transit to fulfillment center
 */
const transitToFulfillmentCenterDetailsSchema = z.object({
    /** Estimated delivery date to fulfillment center in ms since epoch */
    estimatedDeliveryDateToFulfillmentCenter: z.number().int().positive(),
    /** Optional vehicle tracking reference */
    vehicleTrackingReference: z.string().optional(),
    /** Optional contact number */
    contactNumber: z.string().optional(),
    /** Optional company name */
    companyName: z.string().optional(),
});
/**
 * Mark in transit to fulfillment center body schema
 * (for POST /:orderId/mark-in-transit-to-fulfillment-center)
 */
const markInTransitToFulfillmentCenterBodySchema = z.object({
    transitToFulfillmentCenterDetails: transitToFulfillmentCenterDetailsSchema,
});
/**
 * Mark in transit to fulfillment center form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markInTransitToFulfillmentCenterFormSchema)
 */
const markInTransitToFulfillmentCenterFormSchema = z.object({
    transitToFulfillmentCenterDetails: transitToFulfillmentCenterDetailsSchema,
});

export { markInTransitToFulfillmentCenterBodySchema, markInTransitToFulfillmentCenterFormSchema, transitToFulfillmentCenterDetailsSchema };
//# sourceMappingURL=transitValidation.js.map
